<div 
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30"
    (click)="$event.preventDefault(); cancelDelete();"
>
    <div class="bg-white p-6 w-1/3 xl:w-1/4 rounded-md shadow-lg text-center" (click)="$event.stopPropagation()">
        <div class="w-full flex flex-col items-center justify-center gap-4">
            <div class="w-full flex items-center justify-between">
                <div class="flex items-center gap-2">
                    <div class="p-2 rounded-full bg-red-100">
                        <lucide-icon [name]="icons.Trash2" [size]="24" class="text-red-700"></lucide-icon>
                    </div>
                    <h2 class="oswald-font text-xl font-medium text-red-700 text-start">
                        Delete {{ text }}?
                    </h2>
                </div>
                <button (click)="$event.preventDefault(); cancelDelete();">
                    <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                </button>
            </div>
            <p class="w-full text-start pb-4 border-b border-red-300">If you delete this will be gone forever. Are
                you sure you want to proceed?</p>
            <div class="w-full flex items-center justify-end gap-3">
                <button class="px-4 py-2 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    (click)="$event.preventDefault(); cancelDelete();">Cancel</button>
                <button
                    class="px-4 py-2 w-20 rounded-md border border-red-100 bg-gradient-to-b from-red-500 to-red-700 oswald-font text-white"
                    (click)="$event.preventDefault(); deleteItem();">Delete</button>
            </div>
        </div>
    </div>
</div>